import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Available icon names in the icon component
 */
export type IconName =
  | 'external-link'
  | 'activity'
  | 'contribute'
  | 'grant'
  | 'invest'
  | 'transfer'
  | 'currency-conversion'
  | 'error'
  | 'star'
  | 'empty-document'
  | 'close'
  | 'close-circle'
  | 'sort'
  | 'filter'
  | 'exclamation-outline'
  | 'chevron-down'
  | 'chevron-right'
  | 'chevron-left'
  | 'required-asterisk'
  | 'trash'
  | 'trash-outline'
  | 'settings'
  | 'info-circle'
  | 'search'
  | 'circle-check'
  | 'copy'
  | 'plus'
  | 'arrow-left'
  | 'edit'
  | 'clock'
  | 'cancel'
  | 'save'
  | 'menu'
  | 'wand'
  | 'check-square'
  | 'send'
  | 'lock'
  | 'rocket'
  | 'list'
  | 'eye';

@Component({
  selector: 'app-icon',
  imports: [CommonModule],
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss',
})
export class IconComponent {
  /**
   * The name of the icon to display
   */
  name = input.required<IconName>();

  /**
   * The size of the icon in pixels
   */
  size = input<number>(16);

  /**
   * The color of the icon (CSS color value)
   */
  color = input<string>('currentColor');
}
